import React, { ReactNode, useEffect, useMemo } from 'react'
import { redirectFromCvToAiDomain } from 'Utils/common.utils'
import { cvPlaymentDomain } from 'Constants/auth.constants'
import { Loader } from '../Loader/Loader'

type DomainRedirectProps = {
    children: ReactNode
}

export const DomainRedirect: React.FC<DomainRedirectProps> = ({ children }) => {
    const isCvDomain = useMemo(() => window.location.host.includes(cvPlaymentDomain), [])

    useEffect(() => {
        if (isCvDomain) {
            redirectFromCvToAiDomain()
        }
    }, [isCvDomain])

    return isCvDomain ? <Loader title="Redirecting to new url..." /> : <>{children}</>
}
